<template>
  <a-modal
    :title="dialogTitle"
    :visible="visible"
    :mask-closable="false"
    :width="400"
    :confirm-loading="loading"
    destroy-on-close
    @cancel="handleCancel"
    @ok="handleOk('form')"
  >
    <a-form-model
      ref="form"
      :model="form"
      label-align="right"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
      :rules="validateRules"
    >
      <a-form-model-item
        label="产品类型:"
        prop="productTypeId"
      >
        <a-select
          v-model="form.productTypeId"
          placeholder="请选择产品类型"
          allow-clear
          show-search
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="item in productTypetions"
            :key="item.productTypeId"
          >
            {{ item.productTypeName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        label="产品名称:"
        prop="productName"
      >
        <a-input
          v-model="form.productName"
          placeholder="请填写产品名称"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item
        label="产品税率:"
        prop="taxRate"
      >
        <a-input-number
          v-model="form.taxRate"
          :formatter="value => `${value}%`"
          :parser="value => value.replace('%', '')"
          placeholder="请选择产品税率"
          allow-clear
          style="width: 100%;"
          :min="0"
          :disabled="!form.rateEdit"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { updateProduct, addProduct } from '@/api/productManage'
import moment from 'moment'
import { deepClone, filterOption } from '@/utils/utils.js'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    initData: {
      type: Object,
      default: null
    },
    dialogTitle: {
      type: String,
      default: null
    },
    productTypetions: {
      type: Array,
      default: null
    },
    actionType: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      form: {
        productTypeId: undefined,
        productName: undefined,
        taxRate: undefined
      },
      validateRules: {
        productTypeId: [{ required: true, message: '请选择产品类型' }],
        productName: [{ required: true, message: '请输入产品名称' }],
        taxRate: [{ required: true, message: '请输入产品税率' }]
      },
      baseTemp: [],
      monthFormat: 'YYYY/MM'
    }
  },
  watch: {
    initData: {
      deep: true,
      handler: function (data) {
        this.form = this.deepClone(data)
      }
    }
  },
  methods: {
    moment,
    deepClone,
    filterOption,
    handleCancel () {
      this.$refs.form.resetFields()
      this.$emit('cancel')
    },
    handleOk (form) {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.actionType === '0') {
            await updateProduct(
              { ...this.form }
            ).then(() => {
              this.$message.success('提交成功!')
              this.$emit('ok')
            })
          } else {
            await addProduct(
              { ...this.form }
            ).then(() => {
              this.$message.success('提交成功!')
              this.$emit('ok')
            })
          }
        }
      })
    }
  }
}
</script>
